import NotFound from '@/components/NotFound';
import MobileDetect from 'mobile-detect';
import Vue from 'vue';
import routes from 'vue-auto-routing';
import Router from 'vue-router';
import { createRouterLayout } from 'vue-router-layout';

Vue.use(Router);
const RouterLayout = createRouterLayout((layout) => {
  return import('@/layouts/' + layout + '.vue');
});

const removeLocale = (path) => {
  const regex = new RegExp(
    '/(' + process.env.VUE_APP_I18N_SUPPORTED_LOCALE + ')'
  );

  return path.replace(regex, '');
};

const router = new Router({
  mode  : 'history',
  base  : process.env.BASE_URL,
  routes: [
    {
      path       : process.env.BASE_URL,
      alias      : '/(' + process.env.VUE_APP_I18N_SUPPORTED_LOCALE + ')*',
      component  : RouterLayout,
      children   : routes,
      beforeEnter: (to, from, next) => {
        if (process.env.NODE_ENV === 'production') {
          const isMobileDetect = new MobileDetect(
            window.navigator.userAgent
          ).mobile();

          if (window.location.protocol === 'http:') {
            window.location.href = window.location.href.replace(
              'http:',
              'https:'
            );
          } else if (
            !!isMobileDetect &&
            window.location.host.indexOf('m.') < 0
          ) {
            // //www. -> //m.
            const path = window.location.href.replace(/\/\/(www.|)/i, '//m.');

            // //m.~/p_ -> //m.~/m_
            window.location.href = path.replace(
              /(?=\/\/m.)(.+)(\/p_)/i,
              '$1/m_'
            );
          }
        }

        next();
      }
    },
    {
      path     : '/404',
      component: NotFound
    },
    {
      path    : '*',
      redirect: '/404'
    }
  ],
  scrollBehavior(to, from, savedPosition) {
    // 같은 경로안에서 탭이동(hash 변경) 시 스크롤 유지 // 언어 변경 시 스클롤 유지를 위한 removeLocale() 후 비교
    if (removeLocale(to.path) === removeLocale(from.path)) {
      return savedPosition;
    }

    return { x: 0,
      y: 0 };
  }
});

export default router;
